var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('b-table',{attrs:{"items":_vm.items,"fields":_vm.fields,"borderless":false,"hover":true,"sticky-header":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }